<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public && usuario">
      <v-app id="inspire" class="app dashboard">
        <!-- <app-drawer class="app--drawer" :show-drawer="showDrawer"></app-drawer> -->
        <app-toolbar class="app--toolbar"></app-toolbar>
        <!-- <app-toolbar-deuda class="app--toolbar" style="height:55px"></app-toolbar-deuda> -->
        <!-- <div class="toolbar_warning" v-if="usuario.has_debt">
					<img class="toolbar_warning__img_alert" src="./assets/images/alert1.svg" alt />
					<div class="toolbar_warning__regular_text">
						<span class="toolbar_warning__bold-text">Importante: </span> {{this.usuario.has_debt_message}}
					</div>
				</div> -->

        <notifications :user="usuario" />

        <v-content
          style="height: 100%;padding: 96px 0px 0px;"
          v-bind:class="verifyDebt()"
        >
          <!-- Page Header -->
          <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
          <div class="page-wrapper">
            <router-view></router-view>
          </div>

          <!-- App Footer -->
          <v-footer class="footer">
            <div class="footer_section">
              <div class="content_footer">
                <div class="img_logo"></div>
                <div class="middle_content">
                  <div class="middle_content_tittle">Sede San Isidro</div>
                  <div class="middle_content_body">
                    Av. Prescott 333, Lima, PE
                  </div>
                  <div class="middle_content_body">
                    01 219 0150 / 01 219 0151
                  </div>
                  <div class="middle_content_body">
                    idiomas.sanisidro@up.edu.pe
                  </div>
                </div>
                <div class="middle_content">
                  <div class="middle_content_tittle">Sede Miraflores</div>
                  <div class="middle_content_body">
                    Av. Benavides 1657, Lima, PE
                  </div>
                  <div class="middle_content_body">01 219 0152</div>
                  <div class="middle_content_body">
                    idiomas.miraflores@up.edu.pe
                  </div>
                </div>
              </div>
              <div class="line_footer"></div>
              <div class="icons_footer">
                <div class="icons_text">
                  © Copyright - Centro de Idiomas de la Universidad Pacífico
                  2020 - Versión
                  {{ applicationVersion }}
                </div>
                <div class="footer_icons">
                  <div v-for="item in items" :key="item.id">
                    <div
                      class="icons_de_footer"
                      :style="{ 'background-image': 'url(' + item.img + ')' }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </v-footer>
        </v-content>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppToolbar from "@/components/AppToolbar";
import Notifications from "@/components/Notifications";
import moment from "moment";
import { version } from "../package.json";
moment.locale("es-do");

export default {
  name: "App",

  components: {
    AppToolbar,
    notifications: Notifications
  },

  data: () => ({
    items: [
      {
        id: 1,
        img: require("./assets/images/iconFB.svg")
      },
      {
        id: 2,
        img: require("./assets/images/iconYT.png")
      },
      {
        id: 3,
        img: require("./assets/images/iconIN.svg")
      },
      {
        id: 4,
        img: require("./assets/images/iconIG.svg")
      }
    ],
    usuario: null,
    applicationVersion: version
  }),
  mounted() {
    let expiration = localStorage.getItem("expiration");
    if (expiration) {
      let aux = moment(expiration, "DD/MM/YYYY h:mm");
      let momentNow = moment(
        moment().format("DD/MM/YYYY h:mm"),
        "DD/MM/YYYY h:mm"
      );

      if (
        momentNow.diff(aux, "days") >=
        parseInt(process.env.VUE_APP_EXPIRATION_DAYS)
      ) {
        this.$store.dispatch("salir");
      }
    } else {
      this.$store.dispatch("salir");
    }
    this.$store.watch(this.$store.getters.getToken, token => {
      if (token != null && token != undefined) {
        this.usuario = this.$store.state.usuario;
      }
    });
  },
  computed: {
    ...mapState(["secretKeyJwt"])
  },
  async created() {
    this.aux = localStorage.getItem("token");
    if (this.aux) {
      await this.$store.dispatch("autoLogin", this.secretKeyJwt);
      this.usuario = this.$store.state.usuario;
    } else {
      //this.$router.push("/home").catch(err => {});
      this.$router.push("/login").catch(err => {});
    }
  },
  methods: {
    verifyDebt() {
      if (this.usuario.has_debt) {
        return "extra_margin";
      } else return "";
    }
  }
};
</script>
<style lang="scss">
@import "./assets/styles/main";

.v-application {
  font-family: "Open Sans", sans-serif !important;
  line-height: 1.5;
}
.v-application .primary {
  background-color: #00aae7 !important;
  border-color: #00aae7 !important;
}
.extra_margin {
  padding: 151px 0px 0px !important;
  @include respond(phone) {
    padding: 196px 0px 0px !important;
  }
}
.notification_bar {
  position: fixed;
  z-index: 6;
  width: 100%;
  background: #15c26b;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  height: 55px !important;
  margin-top: 96px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  padding: 0 146px;

  @include respond(phone) {
    padding: 25px 30px;
    height: auto !important;
  }

  &__close {
    position: absolute;
    transform: translateY(-50%);
    right: 10px;
    top: 50%;
    color: #fff;
  }
  &__container {
    position: relative;
    width: 100%;
    max-width: 800px;
    display: block;
    margin: 0 auto;
  }
  &__view_more {
    position: absolute;
    width: 108px;
    height: 30px;
    right: 40px;
    border: 1px solid red;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: red;
  }
  &__content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;

    &__regular_text {
      display: flex;
      align-items: center;
      font-weight: normal;
      font-size: 17px;
      margin-left: 10px;
      text-align: center;
      @include respond(phone) {
        display: block;
        text-align: start;
      }
    }
    &__bold-text {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 17px;
      margin-right: 5px;
      text-align: center;
      justify-content: center;
      @include respond(phone) {
        display: inline-block;
        margin-left: 0;
      }
    }
  }
}

.toolbar_warning {
  width: 100%;
  background: #fff2ab;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  height: 55px !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  padding: 0 146px;
  @include respond(phone) {
    // flex-direction: column;
    padding: 25px 30px;
    height: auto !important;
  }
  &__regular_text {
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 17px;
    margin-left: 10px;
    text-align: center;
    @include respond(phone) {
      display: block;
      text-align: start;
    }
  }
  &__bold-text {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 17px;
    margin-left: 15px;
    margin-right: 5px;
    text-align: center;
    justify-content: center;
    @include respond(phone) {
      display: inline-block;
      margin-left: 0;
    }
  }
  .more_container {
    position: relative;
    width: 100%;
    .more_button {
      position: absolute;
      width: 108px;
      height: 30px;
      right: 10px;
      border: 1px solid red;
      box-sizing: border-box;
      border-radius: 6px;
      padding: 0;
      top: 50%;
      transform: translateY(-50%);
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: red;
    }
  }
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #00aae7;
  letter-spacing: 0px;
}
.div-abajo {
  position: fixed; /* Fija el elemento en la ventana del navegador */
  bottom: 0; /* Lo coloca en la parte inferior */
  left: 0; /* Lo coloca en la parte izquierda */
  width: 100%; /* Ocupa todo el ancho */
  padding: 0px 3px 0px 0px; /* Espaciado interno */
  text-align: right; /* Alinea el texto al centro */
  color: #41424e;
  font-size: 8px;
  font-family: "Roboto", "Open Sans";
}
</style>
